import { ChatDocumentKind } from 'ui-component/display/chatFileTypeAssets';
import { getFileFormatFromURL, getFileType } from 'utils/helpers';
import { MessageMediaType } from 'types/chat/messages/common';

const DOC_KINDS: ChatDocumentKind[] = ['pdf', 'docx', 'xlsx', 'zip'];

function extToDocKind(ext: string | null | undefined): ChatDocumentKind | null {
  if (!ext) return null;
  const normalized = ext.toLowerCase();
  return DOC_KINDS.includes(normalized as ChatDocumentKind) ? (normalized as ChatDocumentKind) : null;
}

/** UI-only: infer document kind for chat bubble icons (object name, URL, or declared type). */
export function resolveChatDocumentKind(
  file: string | null | undefined,
  fileType?: MessageMediaType | null,
  mediaNoteFormat?: MessageMediaType | null,
  object?: string | null,
): ChatDocumentKind {
  const fromDeclared =
    extToDocKind(typeof fileType === 'string' ? fileType : null) ??
    extToDocKind(typeof mediaNoteFormat === 'string' ? mediaNoteFormat : null);
  if (fromDeclared) return fromDeclared;

  const fromObject = extToDocKind(object ? getFileType(object) : null);
  if (fromObject) return fromObject;

  const fromUrl = extToDocKind(file ? getFileFormatFromURL(file) : null);
  if (fromUrl) return fromUrl;

  if (fileType === 'document' || mediaNoteFormat === 'document') {
    return 'unknown';
  }

  return 'unknown';
}

export function isLikelyPdfChatFile(
  file: string | null | undefined,
  fileType?: MessageMediaType | null,
  mediaNoteFormat?: MessageMediaType | null,
  object?: string | null,
): boolean {
  return resolveChatDocumentKind(file, fileType, mediaNoteFormat, object) === 'pdf';
}
